import { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import { Card, CardContent } from "shared/components/atoms/card";
import { Image } from "shared/components/atoms/Image";
import tw from "twin.macro";

interface Props {
  imageUrl?: string;
  renderImage?: ReactNode;
  text: string;
  radioInputName: string;
  radios: { label: string; value: any }[];
  onClick?: () => void;
  className?: string;
}

export const RadioGroupCard = ({
  imageUrl,
  renderImage,
  text,
  radioInputName,
  radios,
  onClick,
}: Props) => {
  const { register, watch } = useFormContext();
  const value = watch(radioInputName);
  return (
    <Card tw="w-56">
      {renderImage ? (
        renderImage
      ) : (
        <Image
          src={imageUrl}
          width={222}
          height={107}
          layout="responsive"
          objectFit="cover"
          priority
        />
      )}
      <div tw="divide-y divide-solid">
        <CardContent>
          <p tw="font-normal text-[13px] text-black tracking-[.54px] leading-4 whitespace-pre-wrap">
            {text}
          </p>
        </CardContent>
        <div tw="border-gray py-2 px-0">
          {radios.map((radio) => (
            <div key={radio.value}>
              <input
                {...register(radioInputName)}
                onClick={onClick}
                type="radio"
                value={radio.value}
                id={`${radioInputName}-${radio.value}`}
                tw="hidden"
              />
              <label
                tw="font-normal text-base leading-4 tracking-[.67px] block text-center w-full cursor-pointer py-2.5"
                css={[value == radio.value && tw`text-[#3f1f8e]`]}
                htmlFor={`${radioInputName}-${radio.value}`}
              >
                {radio.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};
